import React, { Suspense, useEffect } from 'react';
import { Route, Redirect, useRouteMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFilterScope } from 'app/actions/Search/search.action';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
import { pageScope } from 'app/constants/mapConstants';
import AllPublicTours from './allPublicTours';
import MyTours from './myTours';
import TourFolders from './tourFolders';
import { retry } from '../../Utility/loadingChunkErrorHandler';
import Filters from './filters';
import {
  SEARCH_BAR_TOUR,
  SEARCH_BAR_ALL,
} from '../../../constants/mainSearch.constants';
import MyFriendsTours from './myFriendsTours';
import MargueritrutenTours from './margueritrutenTours';

const Previewer = React.lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "previewtour" */ '../TourPreview/preview.conteiner'
    )
  )
);

const TourFull = React.lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "tourfull" */ '../TourFullView/TourFullView.container'
    )
  )
);

const Tours = ({ location, setFilterScope }) => {
  const { scope } = useActions();
  let link = '/tour';
  const match = useRouteMatch('/tour/:page');
  if (match) link = match.url;

  const page = match?.params ? match.params.page : 'public';

  useEffect(() => {
    setFilterScope(SEARCH_BAR_TOUR);
    scope(pageScope.tour);
    return () => {
      setFilterScope(SEARCH_BAR_ALL);
    };
  }, []);

  const tourId = parseInt(page.split('_').splice(-1).pop());

  const getFilterComponent = () => {
    if (!tourId || page === 'public' || page === 'list') {
      return <Filters page={page} />;
    }
    return null;
  };

  return (
    <>
      <Route
        path={`${link}`}
        render={(props) => {
          switch (page) {
            case 'public':
            case 'list':
              return (
                <Suspense fallback={<div />}>
                  <AllPublicTours page={page} />
                </Suspense>
              );
            case 'margueritruten':
              return (
                <Suspense fallback={<div />}>
                  <MargueritrutenTours match={match} />
                </Suspense>
              );
            case 'mytour':
              return (
                <Suspense fallback={<div />}>
                  <MyTours {...props} />
                </Suspense>
              );

            case 'folders':
              return (
                <Suspense fallback={<div />}>
                  <TourFolders
                    {...props}
                    folderUrl={location.pathname.split('/')[3]}
                  />
                </Suspense>
              );

            case 'friendtour':
              return (
                <Suspense fallback={<div />}>
                  <MyFriendsTours {...props} />
                </Suspense>
              );
            case 'bookmark':
              return (
                <h1
                  style={{
                    position: 'relative',
                    color: 'grey',
                    margin: '80px 30px',
                  }}
                >
                  Will be available soon
                </h1>
              );

            default:
              if (tourId) {
                return (
                  <Suspense fallback={<div />}>
                    <TourFull {...props} />
                  </Suspense>
                );
              }
              return <Redirect to="/tour" />;
          }
        }}
      />

      <Suspense fallback={<div />}>
        {tourId ? null : <Previewer />}
        {getFilterComponent()}
      </Suspense>
    </>
  );
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setFilterScope,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Tours);
